/**
 * Digital Download Consent
 *
 * Shows a mandatory consent checkbox when the cart contains products tagged
 * 'digital'. The checkbox must be ticked before checkout can proceed.
 *
 * Works on both the cart page and the cart drawer, and re-initialises
 * after AJAX cart updates (via MutationObserver).
 */

(function () {
  'use strict';

  /* ── Initialise consent UI ───────────────────────────────────────── */
  function init() {
    var containers = document.querySelectorAll('.digital-download-consent');

    containers.forEach(function (container) {
      if (container.getAttribute('data-has-digital') !== 'true') {
        container.setAttribute('hidden', '');
        container.style.display = '';
        if (container._consentWasActive) {
          syncCheckoutButtons(true, getCheckoutButtons(container));
          container._consentWasActive = false;
        }
        return;
      }

      container.removeAttribute('hidden');
      container.style.display = '';
      container._consentWasActive = true;

      var checkbox = container.querySelector('.digital-download-consent__checkbox');
      var checkoutBtns = getCheckoutButtons(container);

      if (!checkbox) return;

      /* Set initial state */
      syncCheckoutButtons(checkbox.checked, checkoutBtns);

      /* Remove any stale listeners (in case this runs after a cart re-render) */
      checkbox.removeEventListener('change', checkbox._consentHandler);

      checkbox._consentHandler = function () {
        syncCheckoutButtons(checkbox.checked, checkoutBtns);
      };
      checkbox.addEventListener('change', checkbox._consentHandler);
    });
  }

  /* ── Locate checkout buttons relative to a consent container ──── */
  function getCheckoutButtons(consentContainer) {
    var scope;

    if (consentContainer.closest('.drawer__footer')) {
      scope = consentContainer.closest('.drawer__footer');
    } else if (consentContainer.closest('.cart__footer-wrapper, #main-cart-footer')) {
      scope = consentContainer.closest('.cart__footer-wrapper, #main-cart-footer');
    } else {
      scope = document;
    }

    var btns = [];
    var main = scope.querySelectorAll('[name="checkout"], #CartDrawer-Checkout, #checkout');
    main.forEach(function (b) { btns.push(b); });

    var dynamic = scope.querySelectorAll('.additional-checkout-buttons button, .additional-checkout-buttons [role="button"]');
    dynamic.forEach(function (b) { btns.push(b); });

    return btns;
  }

  /* ── Enable / disable checkout buttons ───────────────────────────── */
  function syncCheckoutButtons(consented, buttons) {
    buttons.forEach(function (btn) {
      if (consented) {
        btn.removeAttribute('disabled');
        btn.classList.remove('button--disabled');
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('button--disabled');
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.5';
      }
    });
  }

  /* ── Block form submission as a safety net ────────────────────────── */
  function blockFormSubmit(e) {
    var form = e.target;
    var consent = form.closest('.cart__footer-wrapper, #main-cart-footer, .drawer__footer');
    if (!consent) consent = document;

    var container = consent.querySelector('.digital-download-consent');
    if (!container || container.hasAttribute('hidden')) return;

    var cb = container.querySelector('.digital-download-consent__checkbox');
    if (cb && !cb.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      container.classList.add('digital-download-consent--shake');
      setTimeout(function () {
        container.classList.remove('digital-download-consent--shake');
      }, 600);
    }
  }

  document.addEventListener('submit', function (e) {
    if (e.target.matches('#cart, #CartDrawer-Form, form[action*="/cart"]') && !e.target.matches('form[action*="/cart/add"]')) {
      blockFormSubmit(e);
    }
  }, true);

  /* ── Re-init after AJAX cart updates ─────────────────────────────── */
  var observer = new MutationObserver(function () {
    init();
  });

  function observe() {
    var targets = document.querySelectorAll(
      '#main-cart-footer, .cart__footer-wrapper, .drawer__footer, cart-drawer'
    );
    targets.forEach(function (t) {
      observer.observe(t, { childList: true, subtree: true });
    });
  }

  /* ── Boot ─────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    init();
    observe();
  });

  if (document.readyState !== 'loading') {
    init();
    observe();
  }
})();
